export const STEPPER_LABELS = {
  GSB1: {
    LABEL: 'Admission Requirement',
    DESCRIPTION: 'Offer to the applicant',
  },
  ACADEMIC_QUALIFICATION: {
    LABEL: 'Academic Qualification',
    DESCRIPTION: '',
  },
  PUBLICATION: {
    LABEL: 'Publication',
    DESCRIPTION: '',
  },
  MERIT: {
    LABEL: 'Merit',
    DESCRIPTION: '',
  },
  SCORES_ON_APPLICANT: {
    LABEL: 'Scores on applicant',
    DESCRIPTION: 'For PPPFS & Competitive 3+1 Matching Fund only',
  },
  DECLARATION: {
    LABEL: 'Declaration',
    DESCRIPTION: '',
  },
  INTERVIEW_PANEL: {
    LABEL: 'Panel Interview',
    DESCRIPTION: '',
  },
  REFEREE_REPORT: {
    LABEL: 'Report Confirmation',
    DESCRIPTION: '',
  },
};
